<!--
패킹 컴포넌트 > 상품정보 > TR
------------------------------------
-->
<template>
    <tr
        :class="classObj"
    >
        <td @click="checked = ! checked">
            <!-- 작업대기 경과시간 -->
            <div class="prepared" v-show="prod.prepared_at" :title="prod.prepared_at">
                {{ prod.prepared_at_text }}
            </div>

            <!-- 완료버튼 -->
            <div class="uncheck-icon" v-show="! checked">
                <i class="material-icons">add_circle_outline</i>

                CLICK
            </div>
            <div class="check-icon" v-show="checked">
                <i class="material-icons">done_outline</i>
            </div>
        </td>
        <td class="highlight">

            <div title="보관장소">
                {{ prod.storage }}
            </div>
            <div class="prod-id-3digit" title="상품번호">
                {{ prod.id_3digit }}
            </div>
            <div v-if="prod.last_error_id">
                <a :href="'/prods/' + prod.id + '/error-info/' + prod.last_error_id" target="_blank" class="uk-link-reset">
                    <span class="uk-label error-history">오류기록</span>
                </a>
            </div>

        </td>

        <td class="amount" :class="prod.amount > 1 ? 'highlight' : null">
            {{ prod.amount }}
        </td>
        <td class="highlight">
            {{ prod.color }}
        </td>
        <td class="highlight">
            {{ prod.size }}
        </td>

        <td class="uk-text-center">
            <img-zoom :src="prod.img_url" disable-preview style="width: 5rem; height: 5rem"></img-zoom>
        </td>
        <td class="uk-text-left">
            <div class="uk-flex uk-flex-top">
                <div class="uk-width-expand">
                    <div class="name">
                        {{ prod.name }}
                    </div>
                    <div class="state uk-position-relative">
                        <i class="material-icons">arrow_right</i>
                        {{ prod.state_text }}

                        <!-- 패킹대기가 아님님 경고 -->
                        <alert
                            class="uk-position-absolute uk-position-center-left-out"
                            msg="패킹대기 상품이 아닙니다. 주의하세요"
                            v-if="prod.state !== 62"
                        >
                        </alert>
                    </div>
                    <div class="price">
                        <i class="material-icons">arrow_right</i>
                        구입단가 : <span class="value">{{ prod.buy_unit_price_text }}</span>
                    </div>
                </div>


                <div class="">
                    <div>
                        <!-- 상세버튼 -->
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-white"
                            onclick="$.app.on_event.move(arguments);"
                            :data-url="'/prods/' + prod.id"
                            data-target="_blank"
                        >
                            <i class="material-icons">link</i>
                            상품상세
                        </button>
                    </div>

                    <div class="uk-margin-small-top">
                        <button
                            class="uk-button uk-button-small uk-button-danger"
                            v-if="! prod.lock_error"

                            @click="$refs.error.form()"
                        >
                            <i class="material-icons">error</i>
                            오류설정
                        </button>
                        <app-check-set-error
                            ref="error"
                            :csrf-token="csrfToken"
                            :prod-id="prod.id"
                            :session-owner="loginUserId"
                            @done="callbackErrorDone"
                        ></app-check-set-error>
                    </div>

                </div>
            </div>

        </td>

    </tr>
</template>

<script>
export default {
    components: {
        'alert': require('./alert.vue').default,
        'img-zoom': require('../../common/img-zoom.vue').default,
    },
    props: {
        // csrf-token
        csrfToken: String,

        /**
         * 로그인 유저 ID
         **/
        loginUserId: {
            type: Number,
            default: null,
        },

        // 상품정보
        prod: Object,
    },
    data: function () {
        return {
            // (bool) 완료여부
            checked: false,
        };
    },
    computed: {
        /**
         * css 클래스명 object
         */
        classObj: function () {
            // 최근작업 여부
            let prepared_lately = false;
            if (this.prod.prepared_at_text
                && (this.prod.prepared_at_text.search('minute') > -1
                    || this.prod.prepared_at_text.search('second') > -1
                )
            ) {
                // 몇분이나 몇초로 텍스트가 작성되는건 전부 최근으로 취급 (1시간이내)
                prepared_lately = true;
            }

            return {
                checked: this.checked,

                // 최근에 작업되었음
                'prepared-lately': prepared_lately,
            };
        },
    },
    methods: {
        /**
         * 에러완료 이벤트 리스너
         */
        callbackErrorDone: function () {
            this.$emit('done:error', null);
        },
    },
}
</script>

<style lang="scss" scoped>
td {
    font-size: 1rem;
    text-align: center;
    padding: 5px;
    font-weight: normal;
    color: #000;
    border: 1px solid #cfcfcf;

    .material-icons {
        vertical-align: middle;
        font-size: 1.5rem;
    }

    &.amount {
        font-size: 1.75rem;
    }
    &.highlight {
        font-size: 1.5rem;
        color: #1e87f0;

        &.amount {
            font-weight: bold;
            color: #ff0000;
        }
    }



    .check-icon {
        color: #1e87f0;

        .material-icons {
            font-size: 2rem;
        }
    }

    .uncheck-icon {
        color: #999;

        .material-icons {
            font-size: 2rem;
        }
    }

    .prod-id-3digit {
        color: #000;
    }

    .name {
        text-align: left;
    }

    .state, .price {
        display: inline-block;
        margin-left: 5px;
        text-align: left;
        font-size: 1rem;
        color: #999;

        .value {
            font-size: 1rem;
            color: #000;
        }
    }
}

tr.checked td {
    background-color: #e6f5ff;
}


tr:hover td {
    background-color: #eee;
}

/**
 * 작업대기 경과시간
 */
.prepared {
    margin-bottom: 5px;
    //color: #999;
    background-color: #999;
    color: #fff;
    //border-radius: 15px;
    //padding: 5px 10px;
    padding: 1px 10px;
    display: inline-block;
}

tr.prepared-lately {
    .prepared {
        background-color: transparent;
        color: #999;
        border-radius: 0;
        padding: 0;
        /*
        color: #000;
        background-color: #fff;
        border: 2px solid #999;
        border-radius: 4px;
        padding: 0.5rem;
         */
    }
}

.error-history {
    border: 1px solid #ec2147;
    background-color: #fff;
    color: #ec2147;
}
</style>